// Local-only fixture for the Ride Details operational-stop UI. Route has
// three stations; the middle one is marked `isOperational: true` so the
// Station chip variant can be exercised without waiting on real data.

const RIDE_ID = '11111111-2222-3333-4444-555555555555';

const CREW_ID = '99999999-aaaa-bbbb-cccc-dddddddddddd';
const CREW = { fullName: 'Freya Njordsdottir' };

const DEN6 = '00000000-1111-1111-1111-111111111111';
const TOR8 = '00000000-2222-2222-2222-222222222222';
const IHP6 = '00000000-3333-3333-3333-333333333333';

export const RIDE_DETAILS_OPERATIONAL_STOP_MOCK = {
	id: RIDE_ID,
	tripNumber: '4200',
	status: 'on_sale',
	departure: '2026-08-10T13:05:00Z',
	lineCode: 'US4200',
	stations: [
		{
			id: DEN6,
			code: 'DEN6',
			name: 'Denver International Airport',
			timezone: 'America/Denver',
			departure: '2026-08-10T13:05:00Z',
			arrival: null,
			isOperational: false,
			city: {
				name: 'Denver, CO',
				id: '00000000-0000-0000-0000-0000000000d1',
				__typename: 'City',
			},
			__typename: 'RideStation',
		},
		{
			id: TOR8,
			code: 'TOR8',
			name: 'Toronto Bus Terminal',
			timezone: 'America/Toronto',
			departure: '2026-08-10T13:07:00Z',
			arrival: '2026-08-10T13:05:00Z',
			isOperational: true,
			city: {
				name: 'Toronto, ON',
				id: '00000000-0000-0000-0000-0000000000t1',
				__typename: 'City',
			},
			__typename: 'RideStation',
		},
		{
			id: IHP6,
			code: 'IHP6',
			name: 'Indianapolis International Airport',
			timezone: 'America/Indiana/Indianapolis',
			departure: null,
			arrival: '2026-08-10T16:00:00Z',
			isOperational: false,
			city: {
				name: 'Indianapolis, IN',
				id: '00000000-0000-0000-0000-0000000000i1',
				__typename: 'City',
			},
			__typename: 'RideStation',
		},
	],
	workAssignmentSequences: [
		{
			isMultiRide: false,
			sequenceGroupId: '00000000-0000-0000-0000-000000000001',
			rideId: RIDE_ID,
			crewMember: {
				id: CREW_ID,
				fullName: CREW.fullName,
				__typename: 'CrewMember',
			},
			breakdown: null,
			fromStation: {
				id: DEN6,
				code: 'DEN6',
				name: 'Denver International Airport',
				timezone: 'America/Denver',
				__typename: 'Station',
			},
			toStation: {
				id: IHP6,
				code: 'IHP6',
				name: 'Indianapolis International Airport',
				timezone: 'America/Indiana/Indianapolis',
				__typename: 'Station',
			},
			fromTimestamp: '2026-08-10T13:05:00Z',
			toTimestamp: '2026-08-10T16:00:00Z',
			activityType: 'driving',
			status: 'confirmed',
			run: null,
			job: null,
			extraActivities: [],
			workAssignments: [
				{
					id: '00000000-0000-0000-0000-00000000wa01',
					version: 1,
					status: 'confirmed',
					crewMember: {
						id: CREW_ID,
						fullName: CREW.fullName,
						__typename: 'Driver',
					},
					fromStation: {
						id: DEN6,
						name: 'Denver International Airport',
						__typename: 'Station',
					},
					toStation: {
						id: IHP6,
						name: 'Indianapolis International Airport',
						__typename: 'Station',
					},
					__typename: 'WorkAssignment',
				},
			],
			ride: {
				id: RIDE_ID,
				stations: [
					{
						id: DEN6,
						code: 'DEN6',
						name: 'Denver International Airport',
						departure: '2026-08-10T13:05:00Z',
						arrival: null,
						__typename: 'RideStation',
					},
					{
						id: TOR8,
						code: 'TOR8',
						name: 'Toronto Bus Terminal',
						departure: '2026-08-10T13:07:00Z',
						arrival: '2026-08-10T13:05:00Z',
						__typename: 'RideStation',
					},
					{
						id: IHP6,
						code: 'IHP6',
						name: 'Indianapolis International Airport',
						departure: null,
						arrival: '2026-08-10T16:00:00Z',
						__typename: 'RideStation',
					},
				],
				__typename: 'Ride',
			},
			__typename: 'WorkAssignmentSequence',
		},
	],
	vehicleAssignments: [],
	activityTypeConfigs: [
		{ activityType: 'driving', limit: 1, __typename: 'ActivityTypeConfig' },
		{ activityType: 'hosting', limit: 0, __typename: 'ActivityTypeConfig' },
	],
	runs: [],
	jobs: [],
	__typename: 'Ride',
};
